import {useTheme} from "@mui/material";
import {observer} from 'mobx-react';
import {useNavigate} from "react-router-dom";
import * as React from "react";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import {styles} from "../login/LoginStyles";
import FormSection from "../../forms/FormSection";
import FormRow from "../../forms/FormRow";
import FilledButton from "../../components/buttons/FilledButton";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import {CUSTOMER_ONBOARDINGS_PATH} from "../../routes";
import CreateCustomerOnboardingRequestFeature from "./CreateCustomerOnboardingFeature";
import FormTextField from "../../components/fields/FormTextField";
import CuitFormatter from "../../utils/CuitRenderer";


function CreateCustomerOnboardingScreen() {
    const application = useApplication();
    const theme = useTheme();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new CreateCustomerOnboardingRequestFeature(application, navigator), navigator);
    const style = styles(theme);
    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const customerOnboardingForm = () => {
        return (
            <FormSection title="Iniciar Alta de Cliente">
                <FormRow>
                    <FormTextField
                        label="CUIT"
                        field={feature.form.getFieldByName("cuit")}
                        formatter={new CuitFormatter()}
                    />
                </FormRow>
            </FormSection>
        )
    }
    const createCustomerOnboardingForm = () => {
        return isFeatureReady(feature) && (
            <div>
                <LayoutContentToolbar
                    title="Nueva alta de cliente"
                    breadcrumbs={[
                        {label: 'Altas de Clientes', path: CUSTOMER_ONBOARDINGS_PATH},
                        {label: 'Nueva'},
                    ]}
                />
                {customerOnboardingForm()}

                <div style={style.buttonsContainer}>
                    <FilledButton disabled={!feature.isFormValid} onClick={() => feature.createCustomerOnboarding()}>
                        Confirmar
                    </FilledButton>
                </div>
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => createCustomerOnboardingForm()}/>
    );
}

export default observer(CreateCustomerOnboardingScreen);
